import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import CustomCard from "../../../../../components/general/CustomCard";
import defaultEmployeeImage from "../../../../../assets/svg/defaultUser.svg";
import { sharedStyles } from "../../../../../styles/shared";

export const EmployeeSelectionForm = ({ employees, selectedEmployeeIds, setSelectedEmployeeIds, noEmployeesSelected }: any) => {
    const { t } = useTranslation();

    const handleSelectEmployee = (employeeId: string) => {
        setSelectedEmployeeIds((prev: string[]) =>
            !prev.includes(employeeId) ? [...prev, employeeId] : prev.filter((id) => id !== employeeId)
        );
    };

    return (
        <>
            <ComercialInterfaceHeader title={t("servicePage.management.form.employeeSelectionTitle")} />
            <Box sx={sharedStyles.serviceEmployeesGrid}>
                {employees?.map((employee: any) => (
                    <Box onClick={() => handleSelectEmployee(employee.id)} key={employee.id}>
                        <CustomCard
                            photoURL={employee.User?.image?.thumbnailUrl}
                            defaultPhoto={defaultEmployeeImage}
                            header={""}
                            primaryText={employee.User?.name}
                            secondaryText={""}
                            isSelected={selectedEmployeeIds.includes(employee.id)}
                        />
                    </Box>
                ))}
            </Box>
            {noEmployeesSelected && (
                <Typography color="error">
                    {t("servicePage.management.form.employeeSelectionError")}
                </Typography>
            )}
        </>
    );
};